import { render, staticRenderFns } from "./MenuSearch.vue?vue&type=template&id=351cfc26"
import script from "./MenuSearch.vue?vue&type=script&lang=js"
export * from "./MenuSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports